@defer (when icon()) {
  <i [title]="icon().tooltip" [class]="icon().icon"></i>
}
